import { AbstractControl } from '@angular/forms';
import { FormValidators } from '@corelabs/angular/forms';

interface ScopeControls {
    schoolId: AbstractControl<string | null>;
    organisationId: AbstractControl<string | null>;
}

/** Organisation admins belong to an organisation, every other role to a school. */
export function updateScopeValidators({ schoolId, organisationId }: ScopeControls, isOrganisationAdmin: boolean): void {
    schoolId.setValidators(isOrganisationAdmin ? null : [FormValidators.Required]);
    organisationId.setValidators(isOrganisationAdmin ? [FormValidators.Required] : null);
    schoolId.updateValueAndValidity();
    organisationId.updateValueAndValidity();
}

/** The API accepts `organisationId` only for organisation admins, so it is left out (`undefined`) for every other role. */
export function toScopeValue(
    { schoolId, organisationId }: { schoolId: string | null; organisationId: string | null },
    isOrganisationAdmin: boolean,
): { schoolId: string | null; organisationId: string | null | undefined } {
    return isOrganisationAdmin ? { schoolId: null, organisationId } : { schoolId, organisationId: undefined };
}
